"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.FooterColumnNav = exports.FooterHtmlContainer = exports.FooterHtmlColumn = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var FooterHtmlColumn = (0, _styled.default)('div')(function (_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      menuFooter = _ref$theme.menuFooter;
  return _ref2 = {
    height: 'auto',
    padding: "".concat(space.xxlarge, " 0 ").concat(space.large),
    color: colors[menuFooter.textColor.copy],
    borderTop: "".concat(menuFooter.borderStyle, " ").concat(colors[menuFooter.borderColor])
  }, _defineProperty(_ref2, mediaQueries.small, {
    border: 'none'
  }), _defineProperty(_ref2, mediaQueries.medium, {
    padding: "".concat(space.small, " 0")
  }), _ref2;
});
exports.FooterHtmlColumn = FooterHtmlColumn;
var FooterHtmlContainer = (0, _styled.default)('div')(function (_ref3) {
  var _ref4;

  var _ref3$theme = _ref3.theme,
      mediaQueries = _ref3$theme.mediaQueries,
      space = _ref3$theme.space;
  return _ref4 = {}, _defineProperty(_ref4, mediaQueries.medium, {
    padding: "".concat(space.small, " 0")
  }), _defineProperty(_ref4, "p", {
    marginBottom: space.small
  }), _ref4;
});
exports.FooterHtmlContainer = FooterHtmlContainer;
var FooterColumnNav = (0, _styled.default)('div')(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      mediaQueries = _ref5$theme.mediaQueries,
      space = _ref5$theme.space;
  return _defineProperty({
    marginBottom: space.medium
  }, mediaQueries.small, {
    marginBottom: 0
  });
});
exports.FooterColumnNav = FooterColumnNav;